<template>
  <div class="navbar">
    <div class="navbar-container">
      <div class="logo-container">
        <img style="width: 100px" src="@/assets/logo.png" alt="Layabox logo" />
      </div>
      <nav class="navbar-menu">
        <el-menu mode="horizontal" :default-active="activeIndex">
          <el-menu-item index="productPrepaidList" @click="goto">MCP</el-menu-item>
          <el-menu-item index="userApiKeys" v-if="isLogin" @click="goto">API Keys</el-menu-item>
          <el-menu-item index="productInstall" @click="goto">安装教程</el-menu-item>
          <el-menu-item index="userServiceInfo" v-if="isLogin" @click="goto">服务信息</el-menu-item>
        </el-menu>
      </nav>
      <div class="right-menu">
        <el-dropdown class="avatar-container" v-if="userInfo">
          <div class="avatar-wrapper nickname-wrapper">
            <span
              >{{ userInfo && userInfo.nickname }}(id:{{
                userInfo && userInfo.developer_uid
              }})</span
            >
            <el-icon><CaretBottom /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="user-dropdown" split-button>
              <el-dropdown-item @click="logout">退出</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div v-else class="sign-in" @click="login">登录</div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useUserStore } from '@/stores/user'
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { tokenWhite, routerMode } from '@/utils'
// 获取路由实例
const router = useRouter()
const userStore = useUserStore()
const userInfo = computed(() => userStore.userInfo)
const isLogin = computed(() => userStore.isLogin)
// const isLogin = ref(false)
console.log('isLogin', isLogin)
const activeIndex = computed(() => {
  return router.currentRoute.value.name
})

// onMounted(() => {
//   isLogin.value = userStore.checkLogin()
// })

async function login() {
  await userStore.login()
  // isLogin.value = userStore.checkLogin()
  // router.push({ path: '/' })
}

async function logout() {
  console.log(router.currentRoute.value.path, router.currentRoute.value.fullPath)
  if (tokenWhite.indexOf(router.currentRoute.value.path) == -1) {
    debugger
    await router.replace({ path: '/' })
  }
  await userStore.logout()

  // if (routerMode == 'hash') {
  //   window.location.href =
  //     window.location.origin + window.location.pathname + '#' + router.currentRoute.value.path
  // }

  // isLogin.value = userStore.checkLogin()
}

function goto(evt) {
  console.log(evt)
  router.push({
    name: evt.index,
  })
}
</script>

<style scoped>
.el-menu--horizontal.el-menu {
  border-bottom: none;
}
.el-menu--horizontal {
  /* flex: 1; */
  justify-content: center;
}
</style>
